module.exports = __webpack_public_path__ + "img/1549045670.06782f09.jpg";